export enum DocumentType {
  PDF = 'pdf',
  HTML = 'html',
  DOCX = 'docx',
  ODT = 'odt'
}
